import { DatesSetArg, EventMountArg } from "@fullcalendar/core";
import dayjs from "dayjs";
import { useCalendarDispatch } from "../context/CalendarContext";
import { changeCurrentViewRange } from "../context/utils";

export default function useFullCalendarHandlers() {
  const dispatch = useCalendarDispatch();

  const handleDateSet = (dataInfo: DatesSetArg) => {
    const startDate = dayjs(dataInfo.startStr, "YYYY-MM-DD");
    const endDate = dayjs(dataInfo.endStr, "YYYY-MM-DD").second(-1);
    changeCurrentViewRange(dispatch, {
      start: startDate.format("YYYY-MM-DD"),
      end: endDate.format("YYYY-MM-DD"),
    });
  };

  const eventDidMount = (eventMount: EventMountArg) => {
    //if (eventMount.event.extendedProps.backgroundColor) {
    if (eventMount.backgroundColor) {
      eventMount.el.style.backgroundColor = eventMount.backgroundColor;
      eventMount.el.style.color = eventMount.textColor;
      eventMount.el.style.borderColor = eventMount.borderColor;
    }
  };

  return {
    handleDateSet,
    eventDidMount,
  };
}
